import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './container.module.scss'

const Container = ({ children, className, fluid }) => (
  <div
    className={ classNames( styles.container, className, {
      [ styles.fluid ]: fluid
    })}
  >
    { children }
  </div>
)

Container.propTypes = {
  children: PropTypes.node.isRequired,
  fluid: PropTypes.bool,
}

Container.defaultProps = {
  fluid: false,
}

export default Container